import { ReactComponent as ChevronUp } from '@public/icons/chevron-up.svg';
import Icon from '../atoms/Icon';

const IconChevronUp = (props) => <Icon as={ChevronUp} {...props} />;

IconChevronUp.propTypes = Icon.propTypes;

export default IconChevronUp;
